module.exports = __webpack_public_path__ + "img/2m.a228aecd.png";